import { render, staticRenderFns } from "./Idea1.vue?vue&type=template&id=ac619f24"
import script from "./Idea1.vue?vue&type=script&lang=js"
export * from "./Idea1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports